<template>
    <div>
        <div class="row" v-if="canViewScorecard">
            <div class="col">
                <div class="my-5 text-center" v-if="loading" key="loading">
                    <h6>{{ $t('vendorQuality.loading') }}</h6>
                </div>
                <scorecard-vendor-summary
                    v-else-if="qualityScorecardSystemId"
                    key="scorecards"
                    :system-id="qualityScorecardSystemId"
                    :vendor-id="resource.id"
                    descending
                    class="my-4 bg-gray-200 border rounded-lg px-4 py-3"
                ></scorecard-vendor-summary>
                <div class="my-5 text-center" v-else key="no_scorecards">
                    <h6>{{ $t('vendorQuality.noScorecards') }}</h6>
                </div>
            </div>
        </div>
        <div
            v-else
            class="my-5 w-100 min-height-150 d-flex justify-content-center align-items-center"
        >
            <div class="font-weight-bold text-muted font-size-100">
                {{ $t('vendorQuality.notAvailable') }}
            </div>
        </div>
    </div>
</template>

<script>
import { suppliosApi } from '../../../js/api-service';
import { errorHandling, currentUserInfoMixin } from "../../../js/custom-vue-mixins";

export default {
    props: ["resource"],
    mixins: [errorHandling, currentUserInfoMixin],
    i18n: {
        messages: {
            en: {
                vendorQuality: {
                    loading: 'Loading...',
                    noScorecards: 'No scorecards to show',
                    notAvailable: 'Scorecards are not available based on your permissions.',
                },
            },
            es: {
                vendorQuality: {
                    loading: 'Cargando...',
                    noScorecards: 'No hay scorecards para mostrar',
                    notAvailable: 'Los scorecards no están disponibles según sus permisos.',
                },
            },
            pt: {
                vendorQuality: {
                    loading: 'Carregando...',
                    noScorecards: 'Nenhum scorecard para exibir',
                    notAvailable: 'Os scorecards não estão disponíveis com base nas suas permissões.',
                },
            },
            'zh-Hans': {
                vendorQuality: {
                    loading: '加载中...',
                    noScorecards: '没有记分卡可显示',
                    notAvailable: '根据您的权限，无法查看记分卡。',
                },
            },
            'zh-Hant': {
                vendorQuality: {
                    loading: '載入中...',
                    noScorecards: '沒有評分卡可顯示',
                    notAvailable: '根據您的權限，無法檢視評分卡。',
                },
            },
        },
    },
    data() {
        return {
            loading: false,
            qualityScorecardSystem: {},  // will fetch from API now - full serialized object
        }
    },
    computed: {
        qualityScorecardSystemId() {
            return this.qualityScorecardSystem?.id ? this.qualityScorecardSystem.id : '';
        },
        canViewScorecard() {
            return true;  // for now, always on, even at N-co.USA
        },
    },
    mounted() {
        this.getQualityScorecardSystem();
    },
    methods: {
        async getQualityScorecardSystem() {
            this.loading = true;
            let resp;
            try {
                resp = await suppliosApi.scorecardSystem.get_quality_system_for_vendor(this.resource.id);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.qualityScorecardSystem = Object.assign({}, resp.data);
            }
            this.loading = false;
        },
    },
};
</script>
